export const toUSD = (amount: number, fractions = 0) => {
  return amount.toLocaleString('en-US', {
    style: 'currency',
    currency: 'USD',
    minimumFractionDigits: fractions,
    maximumFractionDigits: fractions,
  });
};
